var React = require('react');

function IcMenuInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 18C0 16.8954 0.89543 16 2 16H22C23.1046 16 24 16.8954 24 18C24 19.1046 23.1046 20 22 20H2C0.89543 20 0 19.1046 0 18Z","fill":"#19191B","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 10C0 8.89543 0.89543 8 2 8H22C23.1046 8 24 8.89543 24 10C24 11.1046 23.1046 12 22 12H2C0.89543 12 0 11.1046 0 10Z","fill":"#19191B","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 2C0 0.89543 0.89543 0 2 0H22C23.1046 0 24 0.89543 24 2C24 3.10457 23.1046 4 22 4H2C0.89543 4 0 3.10457 0 2Z","fill":"#19191B","key":2})]);
}

IcMenuInline.defaultProps = {"width":"24","height":"20","viewBox":"0 0 24 20","fill":"none"};

module.exports = IcMenuInline;

IcMenuInline.default = IcMenuInline;
